import clsx from "clsx";
import { IconButton } from "nvs-design-system/dist/IconButton";
import {
  IconButtonProps,
  IconButtonType,
} from "nvs-design-system/dist/IconButton/types";
import { useExpansionModalContext } from "./ExpansionModalContext";
import { PropsWithChildren } from "react";

export type Props = PropsWithChildren<Partial<IconButtonProps>>;

const ExpansionModalButtonOpen: React.FC<Props> = ({
  children,
  className,
  onClick,
  buttonType = IconButtonType.outline,
  ...props
}) => {
  const { isOpen, setIsOpen } = useExpansionModalContext();

  return (
    <IconButton
      onClick={(e) => {
        setIsOpen(true);
        onClick && onClick(e);
      }}
      aria-label="expand image button"
      className={clsx(
        "bottom-0 absolute right-0",
        isOpen && "hidden",
        className,
      )}
      title="Open product in fullscreen"
      role="Open Modal"
      buttonType={buttonType}
      {...props}
    >
      {children}
    </IconButton>
  );
};

export default ExpansionModalButtonOpen;
